// CrustData PersonDB ``current_employers.company_headcount_range`` buckets.
//
// The ``value`` carries the comma EXACTLY as Crustdata expects it
// ("501-1,000"). Dropping the comma silently fails the ``in`` match
// server-side — a value of "501-1000" returns nothing. This is the single
// most common way an LLM-emitted size goes wrong, which is why the
// agent-filter mapper normalizes against these values rather than trusting
// the model to reproduce the comma.
//
// Single source of truth, imported by BOTH the People filter sidebar's
// headcount picker and the agent-filter mapper. A vocab-sync test guards
// drift from the backend tool docstring.
export interface CompanySizeBucket {
  value: string;
  label: string;
}

export const COMPANY_SIZE_BUCKETS: CompanySizeBucket[] = [
  { value: '1-10', label: '1-10' },
  { value: '11-50', label: '11-50' },
  { value: '51-200', label: '51-200' },
  { value: '201-500', label: '201-500' },
  { value: '501-1,000', label: '501-1K' },
  { value: '1,001-5,000', label: '1K-5K' },
  { value: '5,001-10,000', label: '5K-10K' },
  { value: '10,001+', label: '10K+' },
];

/** Just the wire values, for membership checks (validation / sync test). */
export const COMPANY_SIZE_VALUES: string[] = COMPANY_SIZE_BUCKETS.map(
  (b) => b.value
);

export const COMPANY_SIZE_BOUNDS = COMPANY_SIZE_BUCKETS.map(({ value }) => {
  const [min, max] = value
    .replace(/,/g, '')
    .replace('+', '')
    .split('-')
    .map(Number);
  return { min, max: max ?? null, range: value.replace(/,/g, '') };
});

export function bucketForCount(count: number): string | null {
  if (!Number.isFinite(count) || count <= 0) return null;
  return (
    COMPANY_SIZE_BOUNDS.find(
      ({ min, max }) => count >= min && (max == null || count <= max)
    )?.range ?? null
  );
}

export const COMPANY_SIZE_FILTER_OPTIONS = COMPANY_SIZE_BUCKETS.map(
  ({ value }) => ({
    id: value.replace(/,/g, ''),
    label: `${value} employees`,
  })
);
